export default __webpack_public_path__ + "static/media/Account-Info.05049209.jpg";